export type ProviderStatus = '草稿' | '审核中' | '发布展示';

export interface ProviderProduct {
  id: string;
  name: string;
  model: string;
  category: string;
  status: ProviderStatus;
  updated: string;
  image: string | null;
  purpose: string;
  features: string;
  scenes: string;
  description: string;
}

export const providerProducts: readonly ProviderProduct[] = [
  {
    id: 'fr-300',
    name: '消防侦察机器人',
    model: 'FR-300',
    category: '侦察与监测设备',
    status: '发布展示',
    updated: '2024-12-01',
    image: '/portals/robot-recon.png',
    purpose: '火场侦察、环境监测、应急通信',
    features: '环境感知、远程操控、多传感器融合、图像回传',
    scenes: '建筑火灾、化工事故等（厂家用途声明）',
    description:
      'FR-300 消防侦察机器人是面向复杂灾害场景的智能化装备示例。厂商资料描述其环境感知、远程操控及信息回传设计。以下内容仅用于产品资料展示，不代表真实技术验证、现场可用性或作业授权。',
  },
  {
    id: 'hm-200',
    name: '高压细水雾灭火系统',
    model: 'HM-200',
    category: '灭火装备',
    status: '审核中',
    updated: '2024-12-09',
    image: null,
    purpose: '细水雾灭火（厂家声明）',
    features: '模块化设计、移动部署',
    scenes: '室内消防演示',
    description: '用于展示高压细水雾设备的产品资料结构；该产品没有提供对应图片，采用品类占位。',
  },
  {
    id: 'uav-800',
    name: '消防巡检无人机',
    model: 'UAV-800',
    category: '无人机',
    status: '发布展示',
    updated: '2024-12-08',
    image: '/portals/drone.png',
    purpose: '巡检观察、影像采集',
    features: '空中视角、图像传输',
    scenes: '巡检用途示例',
    description:
      '消防巡检无人机演示资料，展示厂家产品用途与参数组织。图片为设计包示意素材，不代表任何已授权飞行或实际任务。',
  },
  {
    id: 'ih-01',
    name: '智能消防头盔',
    model: 'IH-01',
    category: '个人防护',
    status: '发布展示',
    updated: '2024-12-06',
    image: null,
    purpose: '个人防护资料示例',
    features: '信息显示设计',
    scenes: '消防防护用途示例',
    description: '个人防护产品样例；认证、实际防护等级与检测报告均未核实。',
  },
  {
    id: 'xt-100',
    name: '消防灭火机器人',
    model: 'XT-100',
    category: '灭火装备',
    status: '草稿',
    updated: '2024-12-05',
    image: '/portals/robot-rescue.png',
    purpose: '灭火装备资料展示',
    features: '履带底盘、远程操控设计',
    scenes: '建筑火灾用途声明',
    description:
      '消防灭火机器人产品资料草稿示例。设计包图片只作产品演示，不能视为现场设备或物理成功证据。',
  },
  {
    id: 'el-300',
    name: '智能消防巡检机器人',
    model: 'EL-300',
    category: '侦察与监测设备',
    status: '草稿',
    updated: '2024-12-02',
    image: null,
    purpose: '巡检资料示例',
    features: '环境监测设计',
    scenes: '日常巡检用途示例',
    description: '巡检产品待补资料示例，没有对应素材，图片保持未知。',
  },
];

export function filterProviderProducts(
  query: string,
  status: string,
  category: string,
): readonly ProviderProduct[] {
  const term = query.trim().toLowerCase();
  return providerProducts.filter(
    (product) =>
      `${product.name} ${product.model} ${product.category}`.toLowerCase().includes(term) &&
      (status === '全部' || product.status === status) &&
      (category === '全部品类' || product.category === category),
  );
}

export function findProviderProduct(id: string): ProviderProduct | undefined {
  return providerProducts.find((product) => product.id === id);
}
